import * as React from 'react';
import { Box, Typography } from '@mui/material';
import Fluid from 'components/Fluid';
import Link from 'components/Link';
import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';

const ComparisonCardBlock = ({cards, title, secondaryTitle, flush, background, backgroundImage, backgroundProps, padding, ...props}) => {

	const swiperRef = React.useRef(null);
	const [swiperKey, setSwiperKey] = React.useState(0);

	React.useEffect(() => {
		setSwiperKey((swiperKey) => swiperKey + 1);
	}, [cards])

	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1280&format=webp&quality=60)`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	if (!cards || cards?.length === 0) return null;

	return (
		<Box sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)}
			className={[
				'comparisonCardBlock__section', 
				(padding ? 'padding-normal' : ''), 
				(flush ? 'margin-flush' : ''),
				(background||'')
			].join(' ')}
		>
			<Fluid layout={{xs: '12', md: '10 2'}} className="comparisonCardBlock__title_wrapper">
				<Typography component="div" variant="h6" className="comparisonCardBlock__title">{(title) ? title : 'If you like'}</Typography>
				<div className="comparisonCardBlock__slider_navigation">
                    <button onClick={() => swiperRef.current?.slidePrev()} aria-label="Previous slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="19" viewBox="0 0 62 19" fill="none">
							<path d="M0.366117 8.32119C-0.122039 8.80935 -0.122039 9.60081 0.366117 10.089L8.32107 18.0439C8.80922 18.5321 9.60068 18.5321 10.0888 18.0439C10.577 17.5558 10.577 16.7643 10.0888 16.2761L3.01777 9.20508L10.0888 2.13401C10.577 1.64585 10.577 0.854399 10.0888 0.366243C9.60068 -0.121912 8.80922 -0.121912 8.32107 0.366243L0.366117 8.32119ZM60.25 10.4551C60.9404 10.4551 61.5 9.89543 61.5 9.20508C61.5 8.51472 60.9404 7.95508 60.25 7.95508V9.20508V10.4551ZM1.25 9.20508V10.4551H60.25V9.20508V7.95508H1.25V9.20508Z" fill="#CECAC0"/>
						</svg>
                    </button>
                    <button onClick={() => swiperRef.current?.slideNext()} aria-label="Next slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="19" viewBox="0 0 62 19" fill="none">
							<path d="M1.25 7.95508C0.559644 7.95508 0 8.51472 0 9.20508C0 9.89543 0.559644 10.4551 1.25 10.4551V9.20508V7.95508ZM61.1339 10.089C61.622 9.60081 61.622 8.80935 61.1339 8.32119L53.1789 0.366243C52.6908 -0.121912 51.8993 -0.121912 51.4112 0.366243C50.923 0.854399 50.923 1.64585 51.4112 2.13401L58.4822 9.20508L51.4112 16.2761C50.923 16.7643 50.923 17.5558 51.4112 18.0439C51.8993 18.5321 52.6908 18.5321 53.1789 18.0439L61.1339 10.089ZM1.25 9.20508V10.4551H60.25V9.20508V7.95508H1.25V9.20508Z" fill="#7E7A69"/>
						</svg>
                    </button>
                </div>
			</Fluid>
			{cards && cards?.length > 0 && 
				<Swiper
					modules={[Autoplay, EffectFade]}
					slidesPerView={1}
		      		// autoplay={{ 
		      		// 	delay: 3000,
		      		// 	pauseOnMouseEnter: true,
		      		// }}
		      		effect={'fade'}
		      		fadeEffect={{
		      			crossFade: true
		      		}}
		      		autoplay={false}
		      		loop={true}
		      		className={'comparisonCardBlock__slider_wrapper'}
		      		speed={1000}
		      		key={swiperKey}
					onBeforeInit={(swiper) => {
						swiperRef.current = swiper;
					}}
				>
				{cards.map((card,index) => {
				let primaryCard = card.find((c) => c.primary === true);
				let secondaryCards = card.filter((c) => c.primary !== true);
				return (
					<SwiperSlide key={`comparison_card_${index}`} className="comparisonCardBlock__slide">
						<Fluid layout={'12'}>
							<Box className="comparisonCardBlock__primary_card">
								<Typography component="div" variant="h1" className="comparisonCardBlock__primary_card_title">{primaryCard?.name}</Typography>
								<Link href={primaryCard?.uri}>
									<Box
										component="span"
										className="comparisonCardBlock__primary_card_image"
										style={{backgroundImage: `url(${process.env.CDN_DOMAIN||''}${primaryCard?.image}?max-w=1920&format=webp)`}}
									/>
								</Link>
							</Box>
						</Fluid>
						{secondaryCards && secondaryCards?.length > 0 && 
						<Box className="comparisonCardBlock__secondary_cards_row">
							<Fluid layout={'12'} alignItems="center" justifyContent="center">
								<Typography component="div" variant="h3" className="comparisonCardBlock__secondary_cards_row_title">{secondaryTitle ? secondaryTitle : 'You Might Also Like'}</Typography>
							</Fluid>
							<Fluid layout={{xs: '6 6'}} gap={'10px'}>
							{secondaryCards.map((secondary, sec_index) => {
								return (
									<Box key={`secondary_card_${sec_index}`} className="comparisonCardBlock__secondary_card">
										<Link href={secondary?.uri}>
											<Box
												component="span"
												className="comparisonCardBlock__secondary_card_image"
												style={{backgroundImage: `url(${process.env.CDN_DOMAIN||''}${secondary?.image}?max-w=1920&format=webp)`}}
											/>
										</Link>
										<Typography component="div" variant="h4" className="comparisonCardBlock__secondary_card_title">{secondary?.name}</Typography>
									</Box>
								)
							})}
							</Fluid>
						</Box>}
					</SwiperSlide>
				)
			})}
			</Swiper>
		}
		</Box>
	)
}

export default React.memo(ComparisonCardBlock);